// components
import '../ui/emergencyPopup.css';
import { Modal } from 'react-async-popup';
import { ConfirmTicketEditionBeforeAcceptanceModal } from './confirmTicketEditionBeforeAcceptanceModal';

const useConfirmTicketEditionBeforeAcceptance = (ticket) => {
  const confirmTicketEditionBeforeAcceptanceModal = async (changes) => {
    const props = { ticket, changes };

    const { show } = await Modal.new({
      content: <ConfirmTicketEditionBeforeAcceptanceModal props={props} />,
      footer: null,
    });
    const result = await show();
    return result;
  };

  const openConfirmTicketEditionBeforeAcceptanceModal = async (changes) => {
    const result = await confirmTicketEditionBeforeAcceptanceModal(changes);
    if (result) {
      return result;
    }
  };

  return {
    openConfirmTicketEditionBeforeAcceptanceModal,
  };
};

export default useConfirmTicketEditionBeforeAcceptance;
